
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { TopMenuItem } from './TopMenuItem'

export const TopMenu = ({ items, className }) => {
  const classMenu = classNames('c-top-menu', 'menu-in-page_container', className, {
  })

  if (!items || !items.length) {
    return null
  }

  return (
    <div className={classMenu}>
      <div className='wrapper'>
        <ul className='menu-in-page_list'>
          {items.map((item, key) => (
            <React.Fragment key={key}>
              <TopMenuItem {...item} />
              {' '}
            </React.Fragment>
          ))}
        </ul>
      </div>
    </div>

  )
}

TopMenu.defaultProps = {
// separator: '/',
}

TopMenu.propTypes = {
  className: PropTypes.string,
  //  callback: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string,
    className: PropTypes.string,
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    callbackData: PropTypes.string
  }))
}
